import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const cancelUnitTaskGroup = async (model: IUnitTaskGroupModel): Promise<IUnitTaskGroupModel> =>
  axios.delete(`/management/UnitProgramTask/CancelTaskGroup?id=${model.id}`).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskGroupModel
}

export const useManagementCancelUnitTaskGroup = (notify?: boolean, onSuccess?: (data: IUnitTaskGroupModel) => void) =>
  useMutation({
    mutationKey: ['cancelUnitTaskGroup'],
    mutationFn: ({ model }: Props) => cancelUnitTaskGroup(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Cancelled task.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to cancel task.')
      }
    },
    throwOnError: false
  })
